import { WidgetCategory } from '../Widget';

export const WidgetMainTypeOptions: Record<string, string> = {
  [WidgetCategory.Graphic]: 'Grafici',
  [WidgetCategory.Input]: 'Input',
  [WidgetCategory.Computed]: 'Calcolati',
  [WidgetCategory.Container]: 'Contenitori',
  [WidgetCategory.Advanced]: 'Avanzati',
};
